const keys = {
  checkout: '@CHECKOUT_COLONIAL_VIRTUAL_OFFICE',
};

export default keys;
